import { Workbox } from "workbox-window";
import { buildRemoteUrl } from "../remote-url/build-remote-url";

export const initServiceWorker = (remoteBaseUrl?: string) => {
  if (!("serviceWorker" in navigator)) return;

  const wb = new Workbox("/sw.js");

  const UPDATE_FLAG_KEY = "sw-update-ready";
  let refreshing = false;

  const markUpdateAvailable = () => {
    localStorage.setItem(UPDATE_FLAG_KEY, "true");
  };

  const clearUpdateFlag = () => {
    localStorage.removeItem(UPDATE_FLAG_KEY);
  };

  const shouldApplyUpdate = () => localStorage.getItem(UPDATE_FLAG_KEY) === "true";

  const reloadApp = () => {
    if (refreshing) return;
    refreshing = true;
    clearUpdateFlag();
    window.location.reload();
  };

  const requestRemotePrefetch = () => {
    if (!remoteBaseUrl) return;
    if (!navigator.onLine) return;

    const targetUrl = buildRemoteUrl(remoteBaseUrl);

    wb.messageSW({
      type: "CACHE_REMOTE",
      payload: {
        baseUrl: remoteBaseUrl,
        targetUrl,
      },
    }).catch((error) => {
      console.warn("[SW] Failed to queue remote prefetch.", error);
    });
  };

  wb.addEventListener("activated", (event) => {
    console.info("[SW] activated; isUpdate =", event.isUpdate);
    requestRemotePrefetch();
  });

  wb.addEventListener("waiting", () => {
    console.info("[SW] New version waiting. Will apply on next launch.");
    markUpdateAvailable();
  });

  wb.addEventListener("controlling", () => {
    if (shouldApplyUpdate()) {
      reloadApp();
    }
  });

  wb.addEventListener("redundant", () => {
    console.warn("[SW] redundant");
  });

  wb.register()
    .then((reg) => {
      console.info("[SW] Registered:", reg);
      setTimeout(() => {
        wb.update();
      }, 1000);

      if (shouldApplyUpdate()) {
        wb.messageSkipWaiting().catch((error) => {
          console.warn("[SW] Failed to apply waiting update.", error);
        });
      }

      if (reg?.active && reg.active.state === "activated") {
        requestRemotePrefetch();
      }
    })
    .catch((err) => {
      console.error("[SW] Failed to register:", err);
    });
};
